import { render, staticRenderFns } from "./ParticipantSub.vue?vue&type=template&id=f1fcd0c6"
import script from "./ParticipantSub.vue?vue&type=script&lang=js"
export * from "./ParticipantSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports